import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import CreateFileSpecCommand from "../FileSpecConfigurations/Models/Commands/CreateFileSpecCommand";
import UpdateFileSpecCommand from "../FileSpecConfigurations/Models/Commands/UpdateFileSpecCommand";
import FileSpecLookup from "../FileSpecConfigurations/Models/Lookups/FileSpecLookup";
import FileTypeLookup from "../FileSpecConfigurations/Models/Lookups/FileTypeLookup";
import FileTypeSearchCriteria from "../FileSpecConfigurations/Models/Queries/FileTypeSearchCriteria";
import GetFileSpecDateOverlapQuery from "../FileSpecConfigurations/Models/Queries/GetFileSpecDateOverlapQuery";

export interface IFileSpecApiClient {
    getFileSpecConfigurationList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileTypeSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FileTypeLookup>>>;
    addNewFileSpec(command: Model.PlainObject<CreateFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateFileSpec(command: Model.PlainObject<UpdateFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    getFileSpecDateOverlapBool(query: GetFileSpecDateOverlapQuery): AxiosPromise<boolean>;
    getFileSpecForFileSpecID(query: number): AxiosPromise<FileSpecLookup>;
}

@injectable()
export default class FileSpecApiClient extends Data.ApiClientBase implements IFileSpecApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/StaticFileSpec`)
    }

    public getFileSpecConfigurationList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileTypeSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FileTypeLookup>>> {
        return this.axios.get(`${this.apiPath}/GetFileSpecConfigurationList?${Utils.getQueryString(payload)}`);
    }

    public addNewFileSpec(command: Model.PlainObject<CreateFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewFileSpec`, command);
    }

    public updateFileSpec(command: Model.PlainObject<UpdateFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.patch(`${this.apiPath}/UpdateFileSpec`, command);
    }

    public getFileSpecDateOverlapBool(query: GetFileSpecDateOverlapQuery): AxiosPromise<boolean> {
        return this.axios.get(`${this.apiPath}/DoesFileSpecOverlapWithExistingFileSpec`, { params: { fileType: query.fileType, fileExtension: query.fileExtension, fileDelimiter: query.fileDelimiter, activeStartDate: query.activeStartDate, staticFileSpecID: query.staticFileSpecID }});
    }

    public getFileSpecForFileSpecID(query: number): AxiosPromise<FileSpecLookup> {
        return this.axios.get(`${this.apiPath}/GetFileSpecForFileSpecID`, { params: { staticFileSpecID: query}});
    }
}